// 课程学习
const zsxxwRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `courseLearning/index${i + 1}`,
  name: `courseLearning/Index${i + 1}`,
  component: () => import(`@/views/study/courseLearning/index${i + 1}.vue`)
}))





export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 课程学习，开始
    ...zsxxwRoutes,
    // 课程学习，结束


  ],
};
